jQuery(document).ready(function ($) {
    //owl carousel is loaded by cdn; but it still needs you to run this script to tell it which div to apply the carousel to
    var carousels = $(".owl-carousel");

    //in case there are multiple .owl-carousels; iterate through the list
    carousels.each(function (i, e) {

        var carousel = $(e);
        var stagePadding = carousel.data("stage-padding");
        var stagePaddingSm = carousel.data("stage-padding-sm");
        var stagePaddingMd = carousel.data("stage-padding-md");
        var stagePaddingLg = carousel.data("stage-padding-lg");
        var stagePaddingXl = carousel.data("stage-padding-xl");

        var items = carousel.data("items");
        var itemsSm = carousel.data("items-sm");
        var itemsMd = carousel.data("items-md");
        var itemsLg = carousel.data("items-lg");
        var itemsXl = carousel.data("items-xl");

        carousel.owlCarousel({
            loop: false,
            margin: 10,
            nav: false,
            dots: false,
            mouseDrag: false,
            touchDrag: false,
            responsive: {
                0: {
                    items: items,
                    stagePadding: stagePadding,
                },
                600: {
                    items: itemsSm,
                    stagePadding: stagePaddingSm
                },
                800: {
                    items: itemsMd,
                    stagePadding: stagePaddingMd
                },
                1200: {
                    items: itemsLg,
                    stagePadding: stagePaddingLg,
                },
                1600: {
                    items: itemsXl,
                    stagePadding: stagePaddingXl,
                },
            }
        });

        //run our own custom triggers because we have our own custom buttons
        let nextCarouselButton = "#" + carousel.attr("id") + "-owl-next";
        let prevCarouselButton = "#" + carousel.attr("id") + "-owl-prev";

        $(nextCarouselButton).click(function () {
            carousel.trigger("next.owl.carousel");
        });
        $(prevCarouselButton).click(function () {
            carousel.trigger("prev.owl.carousel");
        });
    })



});

